import { useEffect, useState } from 'react';

type DynamicImport<T> = () => Promise<T>;

/**
 * Helper for handling dynamic imports, should be used by providing a callback to import:
 *
 * const foo = useDynamicImport(() => import('foo'));
 *
 * N.B. there is no error handling for failed imports.
 */
export const useDynamicImport = <T>(importPromise: DynamicImport<T>): T | null => {
  const [i, setImport] = useState<T | null>(null);

  useEffect(() => {
    importPromise().then(setImport);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return i;
};
